
export const AppConfig = {
VUE_APP_TITLE: 'GongCha',
  // VUE_APP_KAKAO: '"11d748e98b9be0b9b1f3f483e61dd8de"',      // 8863843780bcc786fdb8f56229383fc3
  // VUE_APP_API_DOMAIN: '"http://dev-membership.easymemberhship.co.kr"',
  //VUE_APP_API_DOMAIN: 'http://cloud.motizensoft.com:1005/gongcha', // test
  // VUE_APP_API_DOMAIN: 'http://gongcha.motizensoft.com:8080/gongcha',  // motizen dev
  VUE_APP_API_DOMAIN: 'https://dev-gongcha.easymembership.co.kr/gongcha/gp',  // gongcha dev
  
  VUE_APP_IS_DEV : true,
  VUE_APP_MOBILE_ONLY : false,

  VUE_APP_KAKAO: {
    URL:'/v2/user/me',
    // for Motizen Cloud Server
    KEY : 'a26d9d4c8f0b3eb6553fad98167d7835', // cloud server key
    REST_API_KEY : 'bc9b4efbbce129530ef4b2ad0846913e', // cloud server key

    // gckofficial@naver.com
    // KEY : '8863843780bcc786fdb8f56229383fc3', // localhost    
    // REST_API_KEY : 'b1057bb3b83fc24096ff99f607b36f3a', // localhost
    NATIVE_APP_KEY : '2bda4dc8fdc857154ce0894380930d42'

  },
  VUE_APP_NAVER : {
    URL : 'nid/me',
    ID : 'XdA0udtQxK_AU9OeXL_m'
  },
  // VUE_APP_JUSO_DOMAIN:'"http://www.juso.go.kr/addrlink/addrLinkApi.do"',
  // VUE_APP_ADDRESS_KEY:'"devU01TX0FVVEgyMDIwMTIwOTEwNTEzNjExMDUyMzc="',
  VUE_APP_JUSO_API:{
    GET:'https://www.juso.go.kr/addrlink/addrLinkApi.do',
    // KEY:'devU01TX0FVVEgyMDIwMTIwOTEwNTEzNjExMDUyMzc=',
    POST : 'https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do',
    KEY : 'devU01TX0FVVEgyMDIxMDEyNTEwNDEyNTExMDczODE='
  },
  VUE_APP_CERTIFICATE : {
    URL : 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10.jsp',
    ID : '',
    CERT_TYPE:'H',
    RET_URL : ''
  },
  VUE_APP_PAYMENT_API:{
    // URL:'http://gongcha.motizensoft.com:8080/easypay/mobile/order_req.jsp',    
    URL:'https://dev-gongcha.easymembership.co.kr/gongcha/easypay/mobile/order_req.jsp',    
  },
}


// WEBPACK FOOTER //
// ./src/config/AppConfig.js